import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = {
  key: 0,
  class: "question-label question-label-project2"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.config.textPart2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.config.textPart3)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 3,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.config.textPart4)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 4,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart4, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true),
            _hoisted_9,
            (_ctx.config.nextButtonText)
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 5,
                  class: "mt-4",
                  "color-class": "action-button-project2",
                  text: _ctx.config.nextButtonText,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.next()))
                }, null, 8, ["text"]))
              : (_openBlock(), _createBlock(_component_BackNextButtons, {
                  key: 6,
                  "button-class": "action-button action-button-project2 mt-auto",
                  "go-to": _ctx.goTo,
                  "next-screen": _ctx.config.screenNext
                }, null, 8, ["go-to", "next-screen"]))
          ]),
          (_ctx.config.bgImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-span-4 h-full min-h-50vh flex-col items-center bg-project2-light flex",
                style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: contain; background-position: center; background-repeat: no-repeat; ${_ctx.config.bgStyles}`)
              }, null, 4))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}